<div class="container" id="spinerLoader" *ngIf="loader">
  <div class="loader">Loading...</div>
</div>

<div mat-dialog-title class="modal-header header-radius-4">
  <div class="mx-3 d-flex justify-content-between align-items-center">
    <div>
      <h4>{{data.header}}</h4>
    </div>
    <div>
      <button type="button" class="close close-btn" mat-dialog-close>
        <i class="fa fa-close"></i>
      </button>
    </div>
  </div>
</div>
<mat-dialog-content>
  <div class="p-0 mx-4 mb-4">
    <form id="addCustomer" name="loginForm" #loginForm="ngForm">
      <div class="modal-body">
        <div class="member-card">
          <div class="row">
            <div class="col-lg-6">
              <div class="form-group">
                <label>Name<span class="text-danger">*</span></label>
                <input type="text" id="customerName"
                  [placeholder]="data.header!='Add Partner'?'Customer Name':'Partner Name'" name="CustomerName"
                  maxlength="100" #CustomerName="ngModel" [(ngModel)]="customer.name" class="form-control"
                  [ngClass]="{ 'is-invalid': loginForm.submitted && CustomerName.invalid }" required>
                <div *ngIf="loginForm.submitted && CustomerName.invalid" class="invalid-feedback">
                  <div *ngIf="CustomerName.errors.required"><span style="color: red;">Customer Name is
                      required.</span></div>
                </div>
              </div>
            </div>
            <div class=" col-lg-6" *ngIf="data.header=='Edit Partner'||data.header=='Add Partner'">
              <div class="form-group">
                <label>Type<span class="text-danger">*</span></label>
                <select class="form-control" [(ngModel)]="customer.partnerType" name="type" #type="ngModel"
                  [ngClass]="{ 'is-invalid': loginForm.submitted && type.invalid }" required>
                  <option value="" disabled selected>select</option>
                  <option *ngFor="let type of types" [value]="type.partnerTypeName">{{type.partnerTypeName}}</option>
                </select>
                <div *ngIf="loginForm.submitted && type.invalid" class="invalid-feedback">
                  <div *ngIf="type.errors.required"><span style="color: red;">Type is required.</span></div>
                </div>
              </div>
            </div>
            <div class=" col-lg-6" *ngIf="data.header=='Edit Customer' || data.header == 'Add Customer'">
              <div class="form-group">
                <label>Type<span class="text-danger">*</span></label>
                <select class="form-control" [(ngModel)]="customer.customerType" name="type" #type="ngModel"
                  [ngClass]="{ 'is-invalid': loginForm.submitted && type.invalid }" required>
                  <option [value]="" disabled selected>Select Type</option>
                  <option *ngFor="let type of cmrType" [value]="type.customerTypeName">
                    {{type.customerTypeName}}
                  </option>
                </select>
                <div *ngIf="loginForm.submitted && type.invalid" class="invalid-feedback">
                  <div *ngIf="type.errors.required"><span style="color: red;">Type is required.</span></div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class=" col-lg-6">
              <div class="form-group">
                <label>Phone<span class="text-danger">*</span></label>
                <input type="text" id="primaryContact" placeholder="(xxx) xxx-xxxx"
                  (ngModelChange)="customer.contact.phone=$event" [ngModel]="customer.contact.phone | phoneNumberPipe"
                  name="primaryContact" #primaryContact="ngModel" maxlength="14" minlength="14"
                  pattern="\(?\d+\)?[-.\s]?\d+[-.\s]?\d+" class="form-control"
                  [ngClass]="{ 'is-invalid': loginForm.submitted && primaryContact.invalid }" required>
                <div *ngIf="loginForm.submitted && primaryContact.invalid" class="invalid-feedback">
                  <div *ngIf="primaryContact.errors.required"><span style="color: red;">Phone Number is
                      required.</span></div>
                  <div *ngIf="primaryContact.errors.minlength"><span style="color: red;">Phone must have 10
                      digits.</span></div>
                  <div *ngIf="primaryContact.errors.pattern"><span style="color: red;">Phone Number not valid.</span>
                  </div>
                </div>
              </div>
            </div>
            <div class=" col-lg-6">
              <div class="form-group">
                <label>Email</label>
                <input type="text" id="email" placeholder="Email" name="email" class="form-control" maxlength="50"
                  [(ngModel)]="customer.contact.emailId" />
              </div>
            </div>
          </div>


          <div class="row" *ngIf="data.header=='Add Customer' || data.header =='Edit Customer'">
            <div class=" col-lg-6">
              <div class="form-group">
                <label>PO #</label>
                <div class="pull-right fa-lg text-danger cursorPointer" data-target="#PO" data-toggle="modal"
                  (click)="openPOModel()" title="Add PO#">
                  <i class="fa fa-plus-circle mr-2"></i>
                </div>
                <input type="text" id="poBox" name="poBox" class="form-control" [ngModel]="poBoxValue" readonly>
              </div>
            </div>
            <div class=" col-lg-6">
              <div class="form-group">
                <label>Region</label>
                <select class="form-control" [(ngModel)]="customer.region"
                        name="region"
                        #region="ngModel"
                        [ngClass]="{ 'is-invalid': loginForm.submitted && region.invalid }"
                >
                  <option value="" selected>None</option>
                  <option *ngFor="let region of regionOptions" [value]="region.name" [disabled]="region.isDisabled">
                    {{region.name}}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-6 form-group">
              <label>Contracted Customer</label>
              <div class="radio my-0 contracted">
                <label>
                  <input type="radio" name="isContracted" [(ngModel)]="customer.isContracted" [value]="true" required />
                  <span>Yes</span>
                </label>
                <label>
                  <input type="radio" name="isContracted" [(ngModel)]="customer.isContracted" [value]="false" required />
                  <span>No</span>
                </label>
              </div>
            </div>
            <div class=" col-lg-6">
              <div class="form-group">
                <label>Contracted Response Time for Ground</label>
                <select class="form-control" [(ngModel)]="customer.groundResponseTime"
                        name="groundResponseTime"
                        #groundResponseTime="ngModel"
                        [ngClass]="{ 'is-invalid': loginForm.submitted && groundResponseTime.invalid }"
                >
                  <option *ngFor="let groundResponse of groundResponseTimeOptions" [value]="groundResponse.value" [disabled]="groundResponse.isDisabled">
                    {{groundResponse.name}}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12" *ngIf="data.header=='Add Customer' || data.header =='Edit Customer'">
              <div class="form-group">
                <label>Associated Business Emails</label>
                <i aria-hidden="true" class="fa fa-question-circle fa-lg text-danger ml-2" data-toggle="tooltip"
                  title="Enter comma separated business emails without any space.">
                </i>
                <ng-container>
                  <textarea class="associatedBusinessEmail" name="AssociatedEmails" id="instruction-containerId"
                    placeholder="Enter Business Emails" [(ngModel)]="customer.contact.businessEmail"
                    class="form-control" wrap="hard" row="4" (change)="checkEmail($event)" #AssociatedEmails="ngModel"
                    [ngClass]="{ 'is-invalid': loginForm.submitted && AssociatedEmails.invalid }"></textarea>
                </ng-container>
                <div
                  *ngIf="(loginForm.submitted && AssociatedEmails.invalid) || (loginForm.submitted && invalidEmail==true) || invalidEmail==true">
                  <span style="color: red;">Invalid Associated Emails.</span>
                </div>
              </div>
            </div>
          </div>
        </div>




        <div class="member-card">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Address Type</label><span class="text-danger"> * </span>
                <select name="addressType" #addressType="ngModel" class="form-control"
                  [(ngModel)]="customer.address.addressLocationType"
                  [ngClass]="{ 'is-invalid': loginForm.submitted && addressType.invalid }" required>
                  <option [value]="null" selected disabled>Select Address Type</option>
                  <option *ngFor="let item of AddressType" [value]="item" name="addr_type">
                    {{item}}
                  </option>
                </select>
                <div *ngIf="loginForm.submitted && addressType.invalid" class="invalid-feedback">
                  <div *ngIf="addressType.errors.required"><span style="color: red;">Address Type is
                      required.</span></div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Address</label><span class="text-danger"> * </span>
                <div class="radio my-0">
                  <label><input type="radio" name="pvtOrPublic" #pvtOrPublic="ngModel"
                      [(ngModel)]="customer.address.isGlobal" [value]="false" required />Private</label>
                  <label class="ml-4"><input type="radio" name="pvtOrPublic" #pvtOrPublic="ngModel"
                      [(ngModel)]="customer.address.isGlobal" [value]="true" required />Public</label>
                  <div *ngIf="loginForm.submitted && pvtOrPublic.invalid" class="invalid-feedback">
                    <div *ngIf="pvtOrPublic.errors.required"><span style="color: red;">Field is
                        required.</span></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Street Address</label>
                <input type="text" name="streetAddress" id="CMStreetAddress" placeholder="Street Address"
                  maxlength="150" [(ngModel)]="customer.address.streetAddress" class="form-control" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>Zipcode</label>
                <input type="text" id="CMzipCode" #zipCode="ngModel" placeholder="zipCode" name="zipCode"
                  [(ngModel)]="customer?.address.zipcode" class="form-control" maxlength="5" minlength="3"
                  pattern="[A-Za-z0-9]+" />
                <div *ngIf="loginForm.submitted && zipCode.invalid" class="invalid-feedback">
                  <div *ngIf="zipCode.errors.pattern">
                    <span style="color: red;">ZipCode not valid.</span>
                  </div>
                  <div *ngIf="zipCode.errors.minlength">
                    <span style="color: red;">ZipCode must have 3 or 5 digits.</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <div>
                  <label>State<span class="text-danger">*</span></label>
                  <select name="state" class="form-control" [(ngModel)]="customer.address.stateId" #state="ngModel"
                    (change)="getCityByState(customer.address.stateId)"
                    [ngClass]="{ 'is-invalid': loginForm.submitted && state.invalid }" required>
                    <option value="" selected>select</option>
                    <option *ngFor="let item of stateList" [value]="item.stateId">{{item?.stateName}}</option>
                  </select>
                  <div *ngIf="loginForm.submitted && state.invalid" class="invalid-feedback">
                    <div *ngIf="state.errors.required"><span style="color: red;">State is required.</span></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label>City<span class="text-danger">*</span></label>
                <select name="city" #city="ngModel" class="form-control" [(ngModel)]="customer.address.city"
                  [ngClass]="{ 'is-invalid': loginForm.submitted && city.invalid }" required>
                  <option *ngFor="let addCity of cityList" [value]="addCity.cityName">{{addCity.cityName}}</option>
                </select>
                <div *ngIf="loginForm.submitted && city.invalid" class="invalid-feedback">
                  <div *ngIf="city.errors.required"><span style="color: red;">City is required.</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="member-card" *ngIf="data.header!='Edit Customer' && data.header != 'Add Customer'">
          <h4 class="filter-options my-0">Files</h4>
          <div class="float-right mb-3">
            <input type="file" class="cursorPointer mt-2" accept=".jpg,.jpeg,.png,.pdf" id="partnerFileUpload" multiple
              #fileInput [(ngModel)]="partnerFile" name="partnerFile"
              (input)="partnerFileUpload(partnerFile,'partnerFileUpload')" style="display:none" />
            <a class="py-2 px-3 mr-2 button_style cursorPointer" *ngIf="!editAllFile1" (click)="openFile()">
              Add File
            </a>
            <a class="py-2 px-3 mr-2 cursorPointer button_style_edit" (click)="editAllFile()"
              *ngIf="data?.chooseFile?.length!=0 && !editAllFile1">Edit File</a>
            <button type="button" class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
              *ngIf="editAllFile1" (click)="closeAll()"><i class="fa fa-close fa-md"></i></button>
            <button type="button" class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
              *ngIf="editAllFile1" (click)="closeViewFileModel(false)"><i class="fa fa-check fa-md"></i></button>
          </div>
          <div class="tableMargin">
            <table class="table border-table" data-sort="false" id="tblattach">
              <thead class="table-thead">
                <tr>
                  <td class="header_td p-2" style="border-bottom:1px !important;">
                    <div class="header_container">
                      <div class="header_title" style="width:29.33%">
                        File Name
                      </div>
                      <div class="header_title" style="width:40.33%">
                        File Type
                      </div>
                      <div class="header_title action">
                        Action
                      </div>
                    </div>
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let file of data?.chooseFile|SearchByName: searchText1;let i=index">
                  <td>
                    <div class="row_container">
                      <div class="title_container" [style.width]="isMobileDevice==true?'30.33%':'100%'">
                        <div class="row_title">File Name</div>
                        <div class="row_detail text-color" style="word-break: break-word;" *ngIf="!file.IsEditable">
                          <a [href]="file.filePath" class="text-danger">
                            {{file.fileName}}.{{file.extension}}
                          </a>
                        </div>
                        <div *ngIf="file.IsEditable" class="d-flex">
                          <input type="text" placeholder="File Name" class="form-control mr-2"
                            [(ngModel)]="file.fileName" name="file_name_edit{{i}}" id="file_name_edit{{i}}">
                          <span class="mt-2"><b>.{{file?.extension}}</b></span>
                        </div>
                      </div>
                      <div class="title_container" [style.width]="isMobileDevice==true?'40.33%':'100%'">
                        <div class="row_title">File Type</div>
                        <input type="text" class="form-control" *ngIf="file.IsEditable" [(ngModel)]="file.fileType"
                          id="file_category_edit{{i}}" name="file_category_edit{{i}}" />
                        <div class="row_detail" style="word-break: break-word;" *ngIf="!file.IsEditable">
                          {{file?.extension}}</div>
                      </div>
                      <div class="title_container">
                        <div class="row_title">Action</div>
                        <div class="row_detail">
                          <button class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                            *ngIf="!file.IsEditable" title="Edit License" (click)="fileEdit(i,file)"><i
                              class="fa fa-pencil-square"></i></button>
                          <button class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                            *ngIf="!file.IsEditable" data-target="#message" data-toggle="modal"
                            title="Remove {{file?.fileType}} file" (click)="removeFileForPopup(i)"><i
                              class="fa fa-minus-circle"></i></button>
                          <button type="button" class="flat-butt flat-info-butt flat-info-grad-butt cursorPointer"
                            *ngIf="file.IsEditable" (click)="closeDisable(i)"><i class="fa fa-close fa-md"></i></button>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10"
          *ngIf="data.header=='Add Partner'" mat-dialog-close>Cancel</button>
        <button class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10" type="button"
          *ngIf="data.header=='Add Customer'" mat-dialog-close>Cancel</button>
        <button class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10"
          *ngIf="data.header!='Add Partner' && data.header!='Add Customer'" type=" button"
          mat-dialog-close>Cancel</button>
        <button type="submit" class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
          *ngIf="data.header!='Add Partner' && data.header!='Add Customer'"
          (click)="updateCustomerDetail(loginForm); closeModel()">Save Changes</button>
        <button type="submit" class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
          *ngIf="data.header=='Add Partner'" (click)="addPartner(loginForm)">Save Changes</button>
        <button type="submit" class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
          *ngIf="data.header=='Add Customer'" (click)="addCustomer(loginForm)">Save Changes</button>
      </div>
    </form>
  </div>
</mat-dialog-content>

<div id="PO" class="modal fade" aria-labelledby="PO" tabindex="1" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header content-header">
        <button type="button" class="close close-btn" data-dismiss="modal" aria-label="Close">
          <i class="fa fa-close"></i>
        </button>
        <h4 class="modal-title">
          PO#
          <i *ngIf="poMappingLoader" class="fa fa-spinner fa-spin fa-lg"></i>
        </h4>
      </div>
      <div class="modal-body member-card poModal">
        <form [formGroup]="poForm">
          <div formArrayName="organType">
            <div *ngFor="let organ of this.organType.controls; let i=index">
              <div [formGroupName]="i">
                <div class="mb-2 col-md-6">
                  <div class="col-md-6">{{organ.value.organType}} :</div>
                  <div class="col-md-6">
                    <input class="form-control" type="text" formControlName="organTypeValue"
                      [placeholder]="'Add PO# for '+organ.value.organType">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10"
          data-dismiss="modal">Cancel</button>
        <button type="submit" class="flat-butt flat-info-butt flat-info-grad-butt save-btn" data-dismiss="modal"
          (click)="savePO()">Save Changes</button>
      </div>
    </div>
  </div>
</div>
